import { useEffect, useState } from "react";
import { createHashRouter, RouterProvider } from "react-router-dom";

import Role from "./components/role";
import UserContext, { User } from "./context/user-context";
import EBooksPage from "./pages/ebooks-page/ebooks-page";
import LoginPage from "./pages/login-page";
// import RatingsPage from "./pages/ratings-page/ratings-page";
import { AxiosError } from "axios";
import Redirect from "./components/redirect";
import { getFullLocationUrl } from "./config";
import axios from "./config/axios";
import ChangePasswordPage from "./pages/change-password-page";
import EbookSetupPage from "./pages/ebook-setup-page/ebook-setup-page";
import ForgotPasswordPage from "./pages/forgot-password-page";
import NotFoundPage from "./pages/not-found-page";
import ReportsPage from "./pages/reports-page/reports-page";
import ResetPasswordPage from "./pages/reset-password-page";

const App = () => {
  const [user, setUser] = useState<User>();

  useEffect(() => {
    const loadUser = async () => {
      axios("/api/user")
        .then((res) => setUser(res.data))
        .catch((err: AxiosError<{ status: number; message: string }>) => {
          console.log(err?.response?.data);
          if (
            err?.response?.data?.status === 403 &&
            err?.response?.data?.message.includes("CHANGE_PASSWORD")
          ) {
            const username = err?.response?.data?.message.replace("CHANGE_PASSWORD#", "");
            //@ts-ignore
            window.location = getFullLocationUrl(`#/change-password?username=${username}`);
          } else if (
            !window.location ||
            (!window.location.hash.includes("#/login") &&
              !window.location.hash.includes("#/forgot-password") &&
              !window.location.hash.includes("#/reset-password") &&
              !window.location.hash.includes("#/change-password"))
          ) {
            //@ts-ignore
            window.location = getFullLocationUrl("#/login");
          }
        });
    };
    loadUser();
  }, []);

  const router = createHashRouter([
    {
      path: "/",
      element: <Redirect path={getFullLocationUrl("#/ebooks")} />,
    },
    {
      path: "/ebooks",
      element: <EBooksPage />,
    },
    {
      path: "/ebook-setup",
      element: (
        <Role roles={["EbookTeamMember"]}>
          <EbookSetupPage />
        </Role>
      ),
    },
    {
      path: "/login/:error?",
      element: <LoginPage />,
    },
    {
      path: "/change-password",
      element: <ChangePasswordPage />,
    },
    {
      path: "/forgot-password",
      element: <ForgotPasswordPage />,
    },
    {
      path: "/reset-password",
      element: <ResetPasswordPage />,
    },
    {
      path: "/reports",
      element: <ReportsPage />,
    },
    // {
    //   path: "/ratings",
    //   element: <RatingsPage />,
    // },
    {
      path: "/*",
      element: <NotFoundPage />,
    },
  ]);

  return (
    <UserContext.Provider value={user}>
      <RouterProvider router={router} />
    </UserContext.Provider>
  );
};

export default App;
